import {Form} from '@codeurs/front'
import m from 'mithril'

export default class OptinForm extends Form {
	constructor({data = {}, ...config} = {}) {
		super({
			data: data,
			defaultRequired: false,
			...config
		})
	}

	formSubmit = e => {
		e.preventDefault()
		const {data} = this.fields.store
		return m.request({
			method: 'POST',
			url: '/api/optin',
			data
		})
	}
}
